import { Toast } from 'primereact/toast'
import React, { useEffect, useRef, useState } from 'react'
import api from '../../services/api'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/pt-br'
import { Line } from 'react-chartjs-2'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js'
dayjs.extend(customParseFormat)

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

const Resultado = ({ data_inicial, data_final, categoria_id, initBuscarItens, onBuscarItensEnd }) => {
    const [loading, setLoading] = useState(false)
    const toast = useRef(null)
    const [data, setData] = useState([])

    const buscarItens = async () => {
        try {
            setLoading(true)
            let url = '/api/resultados?data_inicio=' + dayjs(data_inicial).format('DD/MM/YYYY') + '&data_fim=' + dayjs(data_final).format('DD/MM/YYYY')
            
            if (categoria_id) {
                url += '&categoria_id=' + categoria_id
            }
            
            const response = await api.get(url)
            setData(response.data)
        } catch (e) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: e.response?.data?.message || 'Erro ao realizar operação', life: 3000 });
        } finally {
            setLoading(false)
            onBuscarItensEnd()
        }
    }

    useEffect(() => {
        if (initBuscarItens) {
            buscarItens()
        }
    }, [initBuscarItens, categoria_id])

    return (
        <div>
            <Toast ref={toast} position="top-center" />

            {loading && (
                <div className='flex justify-center items-center'>
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                </div>
            )}

            {!loading && data.length > 0 && (
                <div className="chart-container">
                    <Line
                        options={{
                            scales: {
                                y: {
                                    beginAtZero: true
                                }
                            },
                            plugins: {
                                datalabels: {
                                    display: true,
                                    align: 'top',
                                    color: '#000',
                                    font: {
                                        weight: 'bold'
                                    },
                                    formatter: function (value, context) {
                                        return Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
                                    }
                                }
                            }
                        }}
                        data={{
                            labels: data.map(d => d.data),
                            datasets: [
                                {
                                    label: 'Receita',
                                    data: data.map(d => d.receitas),
                                    fill: false,
                                    backgroundColor: 'rgba(20, 210, 20)',
                                    borderColor: 'rgba(20, 210, 20)',
                                    tension: 0.3
                                },
                                {
                                    label: 'Despesa',
                                    data: data.map(d => parseFloat(d.despesas)),
                                    fill: false,
                                    backgroundColor: 'rgba(210, 20, 20)',
                                    borderColor: 'rgba(210, 20, 20)',
                                    tension: 0.3
                                },
                                {
                                    label: 'Competência',
                                    data: data.map(d => parseFloat(d.competencia)),
                                    fill: false,
                                    backgroundColor: 'rgba(20, 20, 210)',
                                    borderColor: 'rgba(20, 20, 210)',
                                    tension: 0.3
                                },
                                {
                                    label: 'Lucro',
                                    data: data.map(d => parseFloat(d.lucro)),
                                    fill: false,
                                    backgroundColor: 'rgba(100, 100, 100)',
                                    borderColor: 'rgba(100, 100, 100)',
                                    tension: 0.3
                                },
                            ],
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default Resultado